import React, { useState, useEffect, useRef } from 'react';
import CustomTitle from '../../components/UI/title/CustomTitle';
import './price5.scss'
import { Helmet } from 'react-helmet';
import PriceInfo from '../../components/PriceInfo/PriceInfo';
import MyButton from '../../components/UI/button/MyButton';
import { useHistory } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.css';
import { Navigation, Pagination, Mousewheel } from 'swiper/modules';
import mixpanel from 'mixpanel-browser';
const Price5 = ({ setShowTermBundle, setButtonText, setButtonShow, setPriceBottomShow, setWhiteWrapper, setEventProperties, sessionId, setEventName }) => {
    const history = useHistory();
    useEffect(() => {
        setButtonShow(false);
        if (setWhiteWrapper) {
            setWhiteWrapper(true)
        }
        // setEventName('web_price')
        // setEventProperties({
        //     web_entrance: localStorage.getItem('signupMethod') === "Login" ? 'login' : 'signup',
        //     session_id: sessionId,
        //     user_id: localStorage.getItem('userId')
        // })
        setPriceBottomShow(false);
        // localStorage.setItem("price", 'plus')
        // localStorage.setItem("plan", '4-Week Plan')
        localStorage.setItem("price", 1)
        const setVHVariable = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        setVHVariable();
        window.addEventListener('resize', setVHVariable);
        return () => window.removeEventListener('resize', setVHVariable);
    }, []);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activePlan, setActivePlan] = useState(1);
    const [activePrice, setActivePrice] = useState('$29.95');
    const [activeOldPrice, setActiveOldPrice] = useState('$83.00');

    const plans = [
        {
            id: 0,
            name: '2 weeks ',
            price: '$19.95',
            oldPrice: '$42.00',
            priceDay: '$79.95/month',
            sale: '54%',
            features: [
                {
                    text: 'Launch up to 50 campaigns',
                    status: true
                },
                {
                    text: 'Build up to 100 creatives',
                    status: true
                },
                {
                    text: 'Create up to 10 AI avatar videos',
                    status: true
                },
                {
                    text: 'Add unlimited products',
                    status: true
                },
                {
                    text: 'Integrate Paypal & Stripe',
                    status: true
                },
                {
                    text: 'Get 24/7 support anytime you need it',
                    status: true
                },
            ]
        },
        {
            id: 1,
            name: '1 month',
            price: '$29.95',
            oldPrice: '$83.00',
            // activeTrial: 'Most Popular',
            priceDay: '$79.95/month',
            sale: '64%',
            features: [
                {
                    text: 'Launch up to 100 campaigns',
                    status: true
                },
                {
                    text: 'Build up to 250 creatives',
                    status: true
                },
                {
                    text: 'Create up to 20 AI avatar videos',
                    status: true
                },
                {
                    text: 'Add unlimited products',
                    status: true
                },
                {
                    text: 'Integrate Paypal & Stripe',
                    status: true
                },
                {
                    text: 'Get 24/7 support anytime you need it',
                    status: true
                },
            ]
        },
        {
            id: 2,
            name: '2 months',
            price: '$49.95',
            oldPrice: '$167.00',
            priceDay: '$79.95/month',
            sale: '70%',
            features: [
                {
                    text: 'Launch up to 150 campaigns',
                    status: true
                },
                {
                    text: 'Build up to 500 creatives',
                    status: true
                },
                {
                    text: 'Create up to 30 AI avatar videos',
                    status: true
                },
                {
                    text: 'Add unlimited products',
                    status: true
                },
                {
                    text: 'Integrate Paypal & Stripe',
                    status: true
                },
                {
                    text: 'Get 24/7 support anytime you need it',
                    status: true
                },
            ]
        },
    ];

    const handlePlanClick = (planId, planName, planPrice, planOldPrice) => {
        setActivePlan(planId);
        localStorage.setItem("price", planId)
        localStorage.setItem("plan", planName)
        setActivePrice(planPrice)
        setActiveOldPrice(planOldPrice)
    };



    const [time, setTime] = useState(15 * 60);

    useEffect(() => {
        if (time > 0) {
            const timerId = setInterval(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);

            return () => clearInterval(timerId);
        } else {
            history.push('/');
        }
    }, [time]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
    };
    const prevRef = useRef(null);
    const nextRef = useRef(null);


    const [showInfo, setShowInfo] = useState('');

    const handleSlideChange = (swiper) => {
        setActiveIndex(swiper.activeIndex);
        setShowInfo(false);
        setShowInfo(swiper.activeIndex + 1);
        localStorage.setItem("price", swiper.activeIndex)
    };

    return (
        <div>

            <div className="price5">
                <div className="price5-top">
                    <CustomTitle style={{ marginBottom: "12rem" }} title={`Claim your ${plans[activeIndex].sale} discount!`} />
                    <p style={{ marginBottom: "24rem" }} className="text">Get high-converting ads and videos made by AI for just {plans[activeIndex].price}. One-time offer, don't miss out!</p>
                    <Swiper
                        initialSlide={1}
                        spaceBetween={12}
                        slidesPerView={1}
                        speed={429}
                        mousewheel={true}
                        modules={[Navigation, Pagination, Mousewheel]}
                        navigation={{
                            prevEl: prevRef.current,
                            nextEl: nextRef.current,
                        }}
                        onInit={(swiper) => {
                            swiper.params.navigation.prevEl = prevRef.current;
                            swiper.params.navigation.nextEl = nextRef.current;
                            swiper.navigation.init();
                            swiper.navigation.update();
                        }}
                        pagination={{ clickable: true }}
                        onSlideChange={handleSlideChange}

                    >
                        {plans.map((plan) => (
                            <SwiperSlide>
                                <div
                                    key={plan.id}
                                    className={`price-plans__plan ${activePlan === plan.id ? 'price-plans__plan--active' : ''}`}
                                    onClick={() => handlePlanClick(plan.id, plan.name, plan.price, plan.oldPrice)}
                                >

                                    <div className="price-plans__plan-active-trial"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.66667 2C6.47778 2 6.31944 1.93611 6.19167 1.80833C6.06389 1.68056 6 1.52222 6 1.33333C6 1.14444 6.06389 0.986111 6.19167 0.858333C6.31944 0.730556 6.47778 0.666667 6.66667 0.666667H9.33333C9.52222 0.666667 9.68056 0.730556 9.80833 0.858333C9.93611 0.986111 10 1.14444 10 1.33333C10 1.52222 9.93611 1.68056 9.80833 1.80833C9.68056 1.93611 9.52222 2 9.33333 2H6.66667ZM8 9.33333C8.18889 9.33333 8.34722 9.26945 8.475 9.14167C8.60278 9.01389 8.66667 8.85556 8.66667 8.66667V6C8.66667 5.81111 8.60278 5.65278 8.475 5.525C8.34722 5.39722 8.18889 5.33333 8 5.33333C7.81111 5.33333 7.65278 5.39722 7.525 5.525C7.39722 5.65278 7.33333 5.81111 7.33333 6V8.66667C7.33333 8.85556 7.39722 9.01389 7.525 9.14167C7.65278 9.26945 7.81111 9.33333 8 9.33333ZM8 14.6667C7.17778 14.6667 6.40278 14.5083 5.675 14.1917C4.94722 13.875 4.31111 13.4444 3.76667 12.9C3.22222 12.3556 2.79167 11.7194 2.475 10.9917C2.15833 10.2639 2 9.48889 2 8.66667C2 7.84444 2.15833 7.06944 2.475 6.34167C2.79167 5.61389 3.22222 4.97778 3.76667 4.43333C4.31111 3.88889 4.94722 3.45833 5.675 3.14167C6.40278 2.825 7.17778 2.66667 8 2.66667C8.68889 2.66667 9.35 2.77778 9.98333 3C10.6167 3.22222 11.2111 3.54444 11.7667 3.96667L12.2333 3.5C12.3556 3.37778 12.5111 3.31667 12.7 3.31667C12.8889 3.31667 13.0444 3.37778 13.1667 3.5C13.2889 3.62222 13.35 3.77778 13.35 3.96667C13.35 4.15556 13.2889 4.31111 13.1667 4.43333L12.7 4.9C13.1222 5.45556 13.4444 6.05 13.6667 6.68333C13.8889 7.31667 14 7.97778 14 8.66667C14 9.48889 13.8417 10.2639 13.525 10.9917C13.2083 11.7194 12.7778 12.3556 12.2333 12.9C11.6889 13.4444 11.0528 13.875 10.325 14.1917C9.59722 14.5083 8.82222 14.6667 8 14.6667ZM8 13.3333C9.28889 13.3333 10.3889 12.8778 11.3 11.9667C12.2111 11.0556 12.6667 9.95556 12.6667 8.66667C12.6667 7.37778 12.2111 6.27778 11.3 5.36667C10.3889 4.45556 9.28889 4 8 4C6.71111 4 5.61111 4.45556 4.7 5.36667C3.78889 6.27778 3.33333 7.37778 3.33333 8.66667C3.33333 9.95556 3.78889 11.0556 4.7 11.9667C5.61111 12.8778 6.71111 13.3333 8 13.3333Z" fill="black" />
                                    </svg>


                                        Exclusive deal: {formatTime(time)}</div>
                                    <div className="price-plans__top">


                                        <h2 className="price-plans__plan-title">{plan.name}


                                            <i>{plan.sale}  OFF</i>

                                        </h2>
                                        <p className="price-plans__plan-price">
                                            {plan.price}
                                            <span>{plan.oldPrice}</span>
                                        </p>




                                        <div className="price-plans__plan-day">

                                            <div style={{ position: 'relative', display: 'flex', width: '100%' }}>
                                                <PriceInfo slideChage={showInfo} sessionId={sessionId} eventName={'web_click_pricepricing'} setShowTermBundle={setShowTermBundle} text={`After ${plan.name} ${plan.priceDay}`} />
                                            </div>
                                        </div>
                                    </div>

                                </div></SwiperSlide>
                        ))}


                        <div>
                            <button ref={prevRef} className="swiper-prev"></button>
                            <button ref={nextRef} className="swiper-next"></button>
                        </div>
                    </Swiper>
                    <div className="price-rate">
                        <img src={process.env.PUBLIC_URL + '/img/rate-3.svg'} alt="" />
                        <img src={process.env.PUBLIC_URL + '/img/rate-4.svg'} alt="" />
                    </div>
                </div>




                <div className="price-cancel">

                    <div className="price-cancel-item">
                        <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.50263 20C12.3069 18.427 16.5 14.7524 16.5 10.4645C16.5 4.74981 16.5 2.70721 16.5 2.70721L8.50263 0L0.5 2.70978C0.5 2.70978 0.5 4.75237 0.5 10.467C0.5 14.7524 4.70099 18.427 8.50263 20Z" fill="#CAD4DD" />
                            <path d="M5 9.5L7.5 12L12 7.5" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                        </svg>

                        <p>No commitments. Cancel anytime.</p>
                    </div>
                </div>

                <MyButton
                    // ref={nextPageButtonRef}
                    buttonStatus={'price'}
                    buttonTime={150}
                    buttonText={[`Get Growth for ${plans[activeIndex].price}`, plans[activeIndex].oldPrice]}
                    onClick={() => {
                        mixpanel.track('web_price', {
                            session_id: sessionId,
                            web_entrance: localStorage.getItem('signupMethod') === "Login" ? 'login' : 'signup',
                            user_id: localStorage.getItem('userId'),
                            // web_pay_method: 'CreditCard',
                            web_utm_campaign: localStorage.getItem("utmCampaign"),
                            web_utm_source: localStorage.getItem("utmSource"),
                            web_utm_medium: localStorage.getItem("utmMedium"),
                            web_utm_content: localStorage.getItem("utmContent"),
                            web_utm_term: localStorage.getItem("utmTerm"),
                            isDebug: false,
                            funnel: 'MAIN_v1',
                        });
                        history.push('/trial');
                    }}
                >
                </MyButton>
            </div>
        </div>
    );
}

export default Price5;
